var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer uk-padding-small"},[_c('div',{staticClass:"uk-container uk-container-expand uk-flex uk-flex-center"},[_c('ul',[_c('li',{staticClass:"uk-visible"},[_vm._v(" © "+_vm._s(_vm.currentYear())+" Jack Carpenter ")]),_c('li',[_vm._v("version: "+_vm._s(_vm.versionNumber))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }